import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import moment from 'moment-timezone'
import { togglePlanSection } from "../../../../actions/show_modal_Action";
import PricingHeader from './Elements/pricingHeader'
import { getInitialRoute } from "../../../../utils";
import PaymentMethodDisplay from "./Elements/paymentMethodDisplay";
import { getProductAndPlanDetails } from "../../../../actions/product_details_action";
import { useDispatch } from "react-redux";


const getWidgetPlans = (id, plans) => {
    return plans.reduce((acc, curr) => {
        if (id === 4) {
            if (curr.id === id) {
                return curr.plan[0];
            }
        } else {
            if (curr.id === id) {
                return curr.plan.digital;
            }
        }
        return acc;
    }, [])
}

export default function Pricing() {
    const { userData } = useSelector(state => state.authenticated, shallowEqual);
    const route = 'socialwalls';
    var [formData, setFormData] = useState({
        oldplan: userData.UserPlan.planId,
        extendplan: "",
        instantSubscription: "0",
        billingcycle: "1",
        selectedProduct: "6",
        planName: "",
        widget_addon_qty: "0",
        feeds_addon_qty: "0",
        screen_addon_qty:"0",
        isCheckout: "0",
        timezone: moment.tz.guess(),
        startDate: "",
        endDate: "",
        beforeafter: "",
        numberofdays: "",
        coupon: "",
        couponValid: "0",
        gstno: "",
        name: "",
        email: "",
        address: "",
        city: "",
        state: "",
        postcode: "",
        country: "",
        recurringStatus: "1"
    });
    const [checkout, setCheckout] = useState(null);
    const [showOneDayPlan, setOneDayPlan] = useState(false);
    const [coupon, setCoupon] = useState(null);
    const [couponSuccess, setCouponSuccess1] = useState(null);

    const [showFeatures, setShowFeatures] = useState(false);
    const [subscriptionValue, setSubscriptionValue] = useState({
        count: 0,
        value: 0,
        widget_addon_qty:0,
        feeds_addon_qty:0,
        screen_addon_qty:0,
        linkdin_addon_qty: 0,
        twitter_addon_qty: 0,
        widget_value:0,
        feeds_value:0,
        screen_value:0,
        linkdin_value:0,
        twitter_value:0
    });
    const [planChecked, setPlanChecked] = useState(true);
    const [subscriptionChecked, setSubscriptionChecked] = useState(true);
    const [cilpBoardBox, setCilpBoardBox] = useState(true);
    const { plans,eventStartDate, eventEndDate } = useSelector((state) => state.planDetails, shallowEqual);
    const usersActivePlan = userData && Object.keys(userData).length > 0 ? userData.UserPlan : {};
    const widgetPlan = Object.keys(plans).length > 0 ? getWidgetPlans(6, plans) : [];
    const displayPlan = Object.keys(plans).length > 0 ? getWidgetPlans(4, plans) : [];
    const dispatch = useDispatch();
    
    const setCouponSuccess = (respomnse) => {
        if (respomnse) {
            if (respomnse.responseData && respomnse.responseData.length > 0) {
                onChangeUpdateFormData("couponValid", respomnse.responseData[0].couponValid);
                onChangeUpdateFormData("coupon", coupon)
            }
            setCouponSuccess1(respomnse)
        }
        else {
            onChangeUpdateFormData("couponValid", "0");
            onChangeUpdateFormData("coupon", "")
        }

    }

    const updateTimeZone=(zone)=>{
        setFormData((state)=>({...state,timezone:zone}));
    }
    const updateDate=(key,date)=>{
        setFormData((state)=>({...state,[key]:date}));
    }

    const onChangeUpdateFormData = (keyData, value) => {

        formData[keyData] = value
        setFormData(formData)
    }
    const isPlanActive = (planId) => {  
        if (usersActivePlan && Object.keys(usersActivePlan).length > 0) {
            const userPlansList = usersActivePlan.planId.split(",");
            return userPlansList.indexOf(`${planId}`) !== -1;
        }
        return false;
    }

    window.$(".upgrade_notifiction").on('click',function(){
        setCheckout(null);
    })
    
    const hideAddOn = ()=>{
        const userPlansList = usersActivePlan.planId.split(",");
        const freePlanList = ['1','14','53','54','55','58','61'];
        const userPaidPlan = [];
        for(let i of userPlansList){
             if(!freePlanList.includes(i)){
                userPaidPlan.push(i);
             }
        }
        return userPaidPlan.length == 0;
    }

    const clipBoard = () =>{
        navigator.clipboard
        .writeText('TAG20')
        .then(() => {
            document.getElementById("copyText2").style.display = "block";
            setTimeout(() => {document.getElementById("copyText2").style.display = "none"},1000)
        })
    }

    const closeClipBoard = ()=>{
        setCilpBoardBox(false);
    }
    
    useEffect(()=>{
        if(plans.length == 0){
            dispatch(getProductAndPlanDetails());
        }
    },[])


    return (
        <div className="d-flex flex-column-fluid payment_modal_panel">
            <div className="container-fluid p-0">
                <div className=" pt-0 " id="payModal">
                    <div className="main_content plan_list">
                        <PricingHeader togglePlanSection={togglePlanSection} checkout={checkout} setCheckout={setCheckout} route={route} showOneDayPlan={showOneDayPlan} setOneDayPlan={setOneDayPlan} />
                            <PaymentMethodDisplay checkout={checkout} planChecked={planChecked} setPlanChecked={setPlanChecked} displayPlan={displayPlan} isPlanActive={isPlanActive} setCheckout={setCheckout} showFeatures={showFeatures} setShowFeatures={setShowFeatures} subscriptionValue={subscriptionValue} subscriptionChecked={subscriptionChecked} setSubscriptionChecked={setSubscriptionChecked} setSubscriptionValue={setSubscriptionValue} onChangeUpdateFormData={onChangeUpdateFormData} formData={formData} setCoupon={setCoupon} coupon={coupon} couponSuccess={couponSuccess} setCouponSuccess={setCouponSuccess} userData={userData} route={route} showOneDayPlan={showOneDayPlan} setOneDayPlan={setOneDayPlan} updateTimeZone={updateTimeZone} updateDate={updateDate} hideAddOn={hideAddOn()} eventStartDate={eventStartDate} eventEndDate={eventEndDate} cilpBoardBox={cilpBoardBox} closeClipBoard={closeClipBoard} clipBoard={clipBoard}/>
                        </div>
                </div>
            </div>
        </div>
    );
}
